import React, { useEffect } from "react";

const Infra = () => {
  useEffect(() => {
    setTimeout(() => {
      let scrollerTemp = window.scroller;
      if (scrollerTemp) {
        scrollerTemp.update();
      }
    }, 700);
  }, []);

  return (
    <>
      <div className="contacts">
        <h1 className="marquee" data-title=" Our Technology">
          Our Technology
        </h1>
        <div className="top">
          <form>
            <div className="heading">
              <div className="split">OUR TECHNOLOGY</div>
              {/* <div className="split"></div> */}
            </div>
            <span
              style={{ textAlign: "center", marginTop: 15, display: "block" }}
            >
              Cutting-Edge Technologies at Ocean Ceramica Crafting Porcelain
              Slabs with Precision
            </span>
          </form>
        </div>
      </div>
      <div className="abtext" id="block2" style={{ paddingTop: "5%" }}>
        <div className="container-full">
          <div className="flex">
            <h2 className="col">{/*<span>Company Profile</span>*/}</h2>
            <p className="col">
              <span>
                {/*<span style="margin-bottom:12px"> <b> Essence: Unleashing the Power of Innovative Ceramic Products.</b></span><br>*/}
                Welcome to the Ocean Ceramica, where innovation meets
                craftsmanship to create stunning porcelain slabs that redefine
                excellence in the industry. Discover the cutting-edge
                technologies that drive our manufacturing process, ensuring the
                production of premium quality surfaces. Explore our
                state-of-the-art machinery and equipment, including:
                <br />
                <br />
              </span>
            </p>
            <div className="col" />
          </div>
        </div>
      </div>

      <section className="story-section">
        <div className="container">
          <div className="row ">
            {/* Content Column */}
            <div className="content-column col-xl-8 col-lg-6 col-md-12 col-sm-12 ">
              <div className="inner-column pr-0">
                <h2>CONTINUA+ Compaction Technology for Slabs and Tiles</h2>
                <div className="text pt-4">
                  <p>
                    CONTINUA+ at Ocean Ceramica revolutionizes slab
                    manufacturing, offering highly customizable premium large
                    slabs. With Widths up to 1200mm, Heights up to 3200mm, and
                    Thickness from 6mm to 15mm, Redefine your projects with our
                    top-quality, custom slabs.
                  </p>
                  <p>
                    During the sample checking process, we make sure that the
                    physical parameters of the product, such as size, surface,
                    and functional characteristics, should be verified against
                    the Master, design documents, ensuring the quality of the
                    sample meets specified requirements in order to avoid
                    quality problems during our manufacturing process, as well
                    as the reliability and consistency of the manufacturing
                    process and our final product.
                  </p>
                </div>
              </div>
            </div>
            {/* Image Column */}
            <div className="image-column col-xl-4 col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <div className="image">
                  <img src="img/1.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="story-section pt-0">
        <div className="container">
          <div className="row ">
            {/* Image Column */}
            <div className="image-column col-xl-4 col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column pl-0">
                <div className="">
                  <img src="img/2.png" alt="" />
                </div>
              </div>
            </div>
            {/* Content Column */}
            <div className="content-column col-xl-8 col-lg-6 col-md-12 col-sm-12 ">
              <div className="inner-column pr-0 pat-sm-5">
                <h2>
                  {" "}
                  The Durst Digital Gamma 148XD, a single-pass digital
                  decoration printer
                </h2>
                <div className="text pt-4">
                  <p>
                    Printing up to 1400mm width, this single-pass printer with
                    Durst's high-definition technology ensures unmatched
                    precision and repeatability, setting industry standards at
                    Ocean Ceramica.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="story-section pt-5 s-pading">
        <div className="container">
          <div className="row ">
            <div className="content-column col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column pr-0">
                <h2>
                  {" "}
                  Raw Materials into Exquisite Slabs with our SACMI Kilns,
                  equipped with a 5-layer dryer
                </h2>
                <div className="text pt-4">
                  <p>
                    <b></b>
                    <br></br>
                    SACMI kilns, equipped with a 5-layer dryer, are the ideal
                    choice for firing structural ceramics, including slabs and
                    tiles. They are available in both single and double-channel
                    thermal configurations and are compatible with gas or oil
                    heating. We entrust SACMI kilns to craft large slabs that
                    are resilient, eco-friendly, and built to last.
                  </p>
                </div>
              </div>
              <div className="inner-column pr-0">
                <div className="">
                  <img src="img/4.png" alt="" />
                </div>
              </div>
            </div>
            {/* Content Column */}
            <div className="content-column col-xl-6 col-lg-6 col-md-12 col-sm-12 ">
              <div className="inner-column pr-0">
                <div className="">
                  <img src="img/3.png" alt="" />
                </div>
              </div>
              <div className="inner-column pr-0">
                <h2>
                  {" "}
                  Witness the power of precision as our KEDA Polishing Machine
                </h2>
                <div className="text pt-4">
                  <p>
                    Which flawlessly enhances the finish of our large slabs.
                    This high-performance machinery ensures a smooth and
                    lustrous surface that meets the most stringent quality
                    standards.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="story-section pt-5 s-pading">
        <div className="container">
          <div className="row ">
            <div className="content-column col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column pr-0">
                <h2>
                  {" "}
                  Innovative designs with the HOPE Tech Digital Printing Machine
                </h2>
                <div className="text pt-4">
                  <p>
                    This cutting-edge technology offers precision and
                    creativity, bringing vibrant designs to life on ceramic
                    surfaces. Say hello to limitless possibilities and unmatched
                    quality as we transform your ceramics into works of art.
                    Explore the future of ceramics today.
                  </p>
                </div>
              </div>
              <div className="inner-column pr-0">
                <div className="">
                  <img src="img/6.png" alt="" />
                </div>
              </div>
            </div>
            {/* Content Column */}
            <div className="content-column col-xl-6 col-lg-6 col-md-12 col-sm-12 ">
              <div className="inner-column pr-0">
                <div className="">
                  <img src="img/5.png" alt="" />
                </div>
              </div>
              <div className="inner-column pr-0">
                <h2>
                  {" "}
                  Elevated Porcelain Tiles production with SACMI Spray Dryers
                </h2>
                <div className="text pt-4">
                  <p>
                    Sacmi Spray Dryers excel in precision and efficiency,
                    ensuring consistent particle size and quality. Their
                    advanced technology allows for the creation of homogeneous
                    ceramic powders, a vital step in achieving top-tier tile and
                    slab production.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Infra;
